<template>
  <layout :lead="leadInfo" :rooftop="rooftopInfo" :welcome-message="welcomeMessage">
    <div style="margin-bottom: 6rem; position: relative; overflow-x: hidden">
      <div v-if="vehicleData">
        <vehicle-card
          v-for="vehicle in vehicleData.vehicles"
          :key="vehicle.id"
          :vehicle="vehicle"
          :vendor="vehicleData.vendor"
        />
      </div>
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex';
import Layout from '@/layouts/default';
import { VehicleService } from '@/services';
import VehicleCard from '@/components/vehicle-card';
import { PAGE_TITLES } from '@/constants';

export default {
  name: 'ViewVehicle',
  metaInfo: {
    title: PAGE_TITLES['view-vehicle'],
  },
  created() {
    this.getVehicleShares();
  },
  components: {
    Layout,
    VehicleCard,
  },
  data() {
    return {
      welcomeMessage:
        'Here are the profiles of some of the vehicles you liked. Let me know what you think.',
      vehicleData: null,
    };
  },
  computed: {
    ...mapState(['leadInfo', 'rooftopInfo']),
  },
  methods: {
    async getVehicleShares() {
      const vehicleId = this.$route.query.vehicle_id;
      const { data: vehicleData } = await VehicleService.getVehicleShareById(vehicleId);

      this.vehicleData = vehicleData;
    },
  },
};
</script>
